<ng-container [ngTemplateOutlet]="listCountResultTemplate"></ng-container>
@if (showArchive && !showOnlyArchiveAction) {
  <div class="d-flex justify-content-between action-buttons">
    <div class="bulk-archive-left d-flex justify-content-between align-items-center">
      <!-- Custom actions positioned to the left -->
      @for (action of getLeftActions(); track action.id) {
        <button
          type="button"
          class="archive-button me-3"
          [class.disabled]="!hasSelectedItems || action.disabled"
          [ngClass]="action.cssClass"
          [disabled]="!hasSelectedItems || action.disabled"
          (click)="onCustomAction(action)">
          <span class="me-2">
            {{ action.label | translate }}
          </span>
          @if (action.icon) {
            <i class="material-symbols-outlined delete-icon">{{ action.icon }}</i>
          }
        </button>
      }

      @if (!hideSelectAllBtn) {
        <button
          type="button"
          class="archive-button me-3"
          (click)="toggleSelectAll()">
          @if (selectAll) {
            {{ T.common.select_all | translate}}
          }
          @else {
            {{ T.common.deselect_all | translate }}
          }
        </button>
      }
      <button
        type="button"
        class="archive-button"
        (click)="onToggleSelect(!showArchive)">
        {{ T.common.cancel_selection | translate}}
      </button>
    </div>
    <div class="bulk-archive-right d-flex align-items-center">
      <!-- Custom actions positioned to the right (before archive) -->
      @for (action of getRightActions(); track action.id) {
        <button
          type="button"
          class="archive-button me-3"
          [class.disabled]="!hasSelectedItems || action.disabled"
          [ngClass]="action.cssClass"
          [disabled]="!hasSelectedItems || action.disabled"
          (click)="onCustomAction(action)">
          <span class="me-2">
            {{ action.label | translate }}
          </span>
          @if (action.icon) {
            <i class="material-symbols-outlined delete-icon">{{ action.icon }}</i>
          }
        </button>
      }

      <!-- Archive action button (always available if showArchiveAction is true) -->
      @if (showArchiveAction) {
        <button
          type="button"
          class="archive-button"
          [class.disabled]="!hasSelectedItems"
          [disabled]="!hasSelectedItems"
          (click)="onBulkArchive()">
          <span class="me-2 archive-text">
            @if (archiveActionText) {
              {{ archiveActionText }}
            }
            @else {
              {{ T.common.archive | translate }}
            }
          </span>
          <i class="material-symbols-outlined delete-icon">cloud_off</i>
        </button>
      }
    </div>
  </div>
}
@else if (!showArchive && !showOnlyArchiveAction) {
  <div class="d-flex justify-content-between action-buttons">
    @if (isAdmin) {
      <div class="bulk-archive-left d-flex justify-content-between">
        <button
          type="button"
          class="archive-button"
          (click)="onToggleSelect(true)"
          [app-tooltip]="{ position: ['top'], message: T.common.select_to_make_bulk_changes | translate }"
        >
          {{ T.common.select | translate }}
        </button>
      </div>
    }
    <div class="bulk-archive-right">
      <ng-container [ngTemplateOutlet]="sortListButtonTemplate"></ng-container>
    </div>
  </div>
}
@else if (showOnlyArchiveAction && hasSelectedItems) {
  <button
    type="button"
    class="archive-button"
    [disabled]="!hasSelectedItems"
    (click)="onBulkArchive()">
    <span class="me-2">
      @if (archiveActionText) {
        {{ archiveActionText }}
      }
      @else {
        {{ T.common.archive | translate }}
      }
    </span>
    <i class="material-symbols-outlined delete-icon">cloud_off</i>
  </button>
}

<ng-template #sortListButtonTemplate>
  <ng-content select="[sort-list-button-template]"></ng-content>
</ng-template>

<ng-template #listCountResultTemplate>
  <ng-content select="[list-count-result-template]"></ng-content>
</ng-template>

